<template>
    <base-question
            v-bind="$props"
            v-on="$listeners">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th colspan=3 >
                    <span class="question-type-info">
                        *                    
                        <span v-if="question.isMultipleCorrectAnswers" v-html="$t('chooseMultipleAnswers')"></span>
                        <span v-if="!question.isMultipleCorrectAnswers" v-html="$t('chooseOneAnswer')"></span>
                    </span>
                </th>
            </tr>
            </thead>
            <tbody id="answers">
                <tr v-for="(answer, index) in question.answers" >
                    <td class="text-bold" style="width: 50px;">{{index+1}}.</td>
                    <td>
                        {{question.answers[index].value}}

                        <span class="text-red">{{ errors.first(questionIndex + '_answer_' + index) }}</span>
                    </td>
                    <td class="text-center" style="width: 150px;">
                        <div class="pretty p-icon" style="font-size: 20px;">
                            <input
                                    :name="questionIndex + '_answerCorrect'"
                                    type="checkbox"
                                    v-model="question.answers[index].correct"
                                    v-validate="'required'" />
                            <div class="state p-success">
                                <i class="icon fa fa-check"></i>
                                <label></label>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </base-question>
</template>

<script>
    import BaseQuestion from "./BaseQuestion.vue";

    export default {
        extends: BaseQuestion,
        inheritAttrs: false,
        components: {
            BaseQuestion
        },
        mounted: function () {

        },
        watch: {
            ['question.answers']: {
                handler: function (v) {
                    this.$emit("change", this.question);
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    #answers td {
        vertical-align: middle;
    }

    .question-type-info {
        font-weight: 400;
        font-style: italic;
    }
</style>